import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const settingsAPI = {
  // Get public settings (no auth required)
  getPublicSettings: async () => {
    try {
      const response = await axios.get(`${API}/api/settings/public`);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch public settings:', error);
      // Return defaults if API fails
      return {
        guest_login_enabled: true
      };
    }
  }
};

export default settingsAPI;
